import { EnvironmentProviders, Provider } from '@angular/core';

/** Optional feature kind. */
export enum BaasCoreFeatureKind {
    /** Whether we want date & time interception. */
    DateTimeInterception,
    /** Whether we want a full app connected to the BaaS backend. */
    BaasApp,
    /** Whether to use i18n features from @lvflanders/bar and connect them to Angular.
     * Note do not use this feature in case the BaaS App feature is used! */
    I18n,
    /** Apm settings. */
    Apm
}

/** Internal dictionary keeping the order of each enum member */
export const _BAAS_CORE_FEATURE_ORDER: Record<BaasCoreFeatureKind, number> = {
    [BaasCoreFeatureKind.DateTimeInterception]: 0,
    [BaasCoreFeatureKind.BaasApp]: 1,
    [BaasCoreFeatureKind.I18n]: 2,
    [BaasCoreFeatureKind.Apm]: 3
};

/** Represents an optional feature for BaaS Core.  */
export interface BaasCoreFeature {
    /** What kind of feature. */
    kind: BaasCoreFeatureKind;
    /** Providers within the feature. */
    providers: Array<Provider | EnvironmentProviders>;
}
